var _style, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 666.6 666.7",
    style: {
      enableBackground: "new 0 0 666.6 666.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.3;enable-background:new    ;}\n\t.st1{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M233.9,666.2h200c166.7,0,233.3-66.7,233.3-233.3v-200C667.3,66.2,600.6-0.5,433.9-0.5h-200 C67.3-0.5,0.6,66.2,0.6,232.8v200C0.6,599.5,67.3,666.2,233.9,666.2z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M151.1,413V249.3c0-18.5,10.3-28.9,27.9-28.9s27.7,10.4,27.7,28.9v148h68.4c14.8,0,24.7,8.2,24.7,22.4 s-9.7,22.4-24.7,22.4h-96.1C161.4,442.1,151.1,431.5,151.1,413z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M301.1,333c0-69.6,41.8-113.1,107.9-113.1S516.8,263.3,516.8,333S475.2,445.9,409,445.9 C342.7,445.9,301.1,402.6,301.1,333z M460.3,333c0-41.6-20.3-68-51.3-68s-51.3,26.3-51.3,68c0,41.5,20.1,67.8,51.3,67.8 C440.1,400.8,460.3,374.4,460.3,333z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoButton);
export default __webpack_public_path__ + "static/media/lo_button.b0024a3b3387d67199622f4344f72e2e.svg";
export { ForwardRef as ReactComponent };